var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('h3',{staticClass:"example-header"},[_vm._v("Ripple any element, any time")]),_c('div',{attrs:{"id":"AutoSubmit"}},[_vm._v("Auto-submit in "+_vm._s(_vm.auto_submit_in))])])}
var staticRenderFns = []

export { render, staticRenderFns }